import React, { useState, useEffect } from 'react';
import { authConfig, updateAuthConfig } from '../../config/authConfig';
import authService from '../../services/authService'

const SettingsModal = ({ isOpen, onClose, user, onLogout, onUpdateServerUrl }) => {
    const [serverUrl, setServerUrl] = useState(authConfig.authServerUrl);
    const [saveSuccess, setSaveSuccess] = useState(false);

    useEffect(() => {
        if (saveSuccess) {
            const timer = setTimeout(() => setSaveSuccess(false), 3000);
            return () => clearTimeout(timer);
        }
    }, [saveSuccess]);

    const handleSaveSettings = () => {
        updateAuthConfig({
            authServerUrl: serverUrl
        });
        onUpdateServerUrl(serverUrl);
        setSaveSuccess(true);
    };

    if (!isOpen) return null;

    if (authService.getUser() != null) {
        console.log("Get user: " + authService.getUser())

        user = authService.getUser();
        return (
          <div className={`modal ${isOpen ? 'active' : ''}`} onClick={onClose}>
              <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '550px' }}>
                  <div className="modal-header">
                      <h3><i className="fas fa-cog"></i> Настройки</h3>
                      <button className="btn-icon" onClick={onClose}>
                          <i className="fas fa-times"></i>
                      </button>
                  </div>

                  <div style={{ padding: '0.5rem' }}>
                      {/* Информация о пользователе */}
                      {(
                        <div style={{
                            marginBottom: '2rem',
                            padding: '1rem',
                            background: 'var(--primary-light)',
                            borderRadius: '12px'
                        }}>
                            <h4><i className="fas fa-user-circle"></i> Профиль</h4>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginTop: '0.5rem' }}>
                                <div className="chat-avatar"
                                     style={{ width: '60px', height: '60px', fontSize: '1.5rem' }}>
                                    {user.avatar}
                                </div>
                                <div>
                                    <div><strong>{user.username}</strong></div>
                                    <div style={{ fontSize: '0.85rem', color: 'var(--text-secondary)' }}>
                                        <i className="fas fa-envelope"></i> {user.email}
                                    </div>
                                    <div style={{ fontSize: '0.85rem', color: 'var(--text-secondary)' }}>
                                        <i className="fas fa-id-badge"></i> ID: {user.login}
                                    </div>
                                </div>
                            </div>
                        </div>
                      )}

                      {/* Настройки сервера аутентификации */}
                      {/*<div style={{ marginBottom: '2rem' }}>*/}
                      {/*    <h4><i className="fas fa-server"></i> Сервер аутентификации</h4>*/}
                      {/*    <div style={{ marginTop: '0.5rem' }}>*/}
                      {/*        <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.9rem' }}>*/}
                      {/*            URL сервера авторизации*/}
                      {/*        </label>*/}
                      {/*        <input*/}
                      {/*            type="text"*/}
                      {/*            className="message-input"*/}
                      {/*            value={serverUrl}*/}
                      {/*            onChange={(e) => setServerUrl(e.target.value)}*/}
                      {/*            placeholder="https://api.example.com/auth"*/}
                      {/*            style={{ width: '100%', marginBottom: '0.5rem' }}*/}
                      {/*        />*/}
                      {/*        <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', marginBottom: '0.5rem' }}>*/}
                      {/*            <i className="fas fa-info-circle"></i> Пример: https://your-auth-server.com/v1*/}
                      {/*        </div>*/}
                      {/*    </div>*/}
                      {/*</div>*/}

                      {/* Кнопки действий */}
                      <div style={{ display: 'flex', gap: '0.75rem', marginBottom: '1rem' }}>
                          <button className="btn-primary" onClick={handleSaveSettings} style={{ flex: 1 }}>
                              <i className="fas fa-save"></i> Сохранить настройки
                          </button>
                          <button className="btn-outline" onClick={onLogout}
                                  style={{ flex: 1, borderColor: '#e74c3c', color: '#e74c3c' }}>
                              <i className="fas fa-sign-out-alt"></i> Выйти
                          </button>
                      </div>

                      {saveSuccess && (
                        <div style={{
                            background: 'rgba(46, 204, 113, 0.1)',
                            color: 'var(--primary)',
                            padding: '0.5rem',
                            borderRadius: '8px',
                            textAlign: 'center',
                            fontSize: '0.85rem'
                        }}>
                            <i className="fas fa-check-circle"></i> Настройки сохранены!
                        </div>
                      )}

                      <div style={{
                          marginTop: '1rem',
                          paddingTop: '1rem',
                          borderTop: '1px solid var(--border)',
                          fontSize: '0.75rem',
                          color: 'var(--text-secondary)',
                          textAlign: 'center'
                      }}>
                          <i className="fas fa-shield-alt"></i> Версия 1.0.0 | Echo Messenger
                      </div>
                  </div>
              </div>
          </div>
        );
    }
};

export default SettingsModal;

